// Ключи настроек отображения (lib/display-prefs.ts) и тот же applyDisplayPrefs
// строкой для <script> в <head> (app/layout.tsx): срабатывает до первой
// отрисовки. Без него на медленной сети (Турция -> Timeweb) страница несколько
// секунд после перезагрузки была обычного размера без контраста, и казалось,
// что настройки сбросились (04.10.2026). Отдельный файл без React: layout -
// серверный компонент и не может импортировать модуль с хуками.
export const SCALE_KEY = 'tk-text-scale'
export const CONTRAST_KEY = 'tk-contrast'
// Шар Turkido скрыт на экранах с заданиями (тикет 119, 17.10.2026). В boot-скрипт
// не входит: место шара и так выбирает клиент после монтирования.
export const FAB_STEPS_OFF_KEY = 'tk-fab-steps-off'

export const DISPLAY_PREFS_BOOT_SCRIPT = `try{var r=document.documentElement,s=localStorage.getItem('${SCALE_KEY}');if(s==='1.15'||s==='1.3'){r.style.zoom=s;r.classList.add(s==='1.15'?'tk-zoom-115':'tk-zoom-130')}if(localStorage.getItem('${CONTRAST_KEY}')==='1')r.classList.add('tk-contrast')}catch(e){}`
